/**
 * Smooth Scroll Behavior Polyfill
 */
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

/**
 * Swiper
 */
import Swiper, { Navigation } from "swiper";
Swiper.use([Navigation]);

/**
 * Modules
 */
import "./modules/ClosestPolyfill.js";
import BodyScroll from "./modules/BodyScroll.js";
import CustomSelect from "./modules/CustomSelect.js";
import { slideUp, slideDown, slideToggle } from "./modules/SlideBlock.js";
import "./modules/HideDropdownBlocks.js";
import "./modules/Tabs.js";

/**
 * Initiation
 */
const bodyScroll = new BodyScroll();

// new Popup() sss;
if (document.querySelectorAll(".select-wrap option").length) {
  document.querySelectorAll(".select-wrap").forEach((item) => {
    var className = item.className;
    if(className != ""){
      var classNameArray = className.split(" ");
      className = classNameArray.join(".");
      if (document.querySelectorAll("."+className+" select").length) {
        new CustomSelect(item);
      }
    }
  });  
}


function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

/**
 * Newsletter
 */
// const newsletterClose = document.querySelector(".newsletter-close");
// newsletterClose?.addEventListener("click", () => {
//   // Set a cookie for 31 days to not show this banner
//   setCookie("seenNewsletter", "true", 31);
// 
//   slideToggle(newsletterClose.closest(".newsletter"), 350);
// });

const newsletterClose = document.querySelector(".newsletter-close");
newsletterClose?.addEventListener("click", () => {
  // Set a cookie for 1 days to not show this banner
  setCookie("seenCoupon", "true", 1);

  slideToggle(newsletterClose.closest(".newsletter"), 350);
});


// Check fi the gform_confirmation message is on the screen, if it is then set a cookie
var el = document.getElementsByClassName("gform_confirmation_message_4");
if (el.length) {
  // Set a cookie for 31 days to not show this banner
  setCookie("seenNewsletter", "true", 31);
}

/**
 * Header
 */
const header = document.querySelector("header.header");
if (header) {
  const newsletter = document.querySelector(".newsletter");

  const checkHeader = () => {
    const newsletterHeight = newsletter ? newsletter.getBoundingClientRect().height : 0;
    const fromTop = window.scrollY;

    if (newsletter) {
      if (fromTop > newsletterHeight) {
        header.classList.add("-shadow");
      } else {
        header.classList.remove("-shadow");
      }
    } else {
      if (fromTop > 0) {
        header.classList.add("-shadow");
      } else {
        header.classList.remove("-shadow");
      }
    }
  };

  checkHeader();

  window.addEventListener("scroll", () => checkHeader());
}

/**
 * Search
 */

// Search button click event
const searchBtn = document.querySelector(".portfolio-search svg");
if (searchBtn) {
  searchBtn?.addEventListener("click", () => {
    const searchValue = document.querySelector(".search-value");

    // If something is filled in
    if (searchValue.value.length) {
      window.location.href = `${site_url}?s=${searchValue.value}`;
    }
  });
}

// Search form on enter event
const searchinput = document.querySelector(".search-value");
if (searchinput) {
  searchinput.addEventListener("keyup", function (event) {
    event.preventDefault();

    if (event.keyCode === 13) {
      const searchValue = document.querySelector(".search-value");

      // If something is filled in
      if (searchValue.value.length) {
        window.location.href = `${site_url}?s=${searchValue.value}`;
      }
    }
  });
}

/**
 * Nav
 */
const nav = document.querySelector("nav.header-nav");
if (nav) {
  const subNavTriggers = nav.querySelectorAll("li.menu-item-has-children");
  subNavTriggers.forEach((trigger) => {
    trigger.addEventListener("click", function (e) {
      if (window.innerWidth < 1170 && e.target === trigger) {
        trigger.classList.toggle("active");
        slideToggle(trigger.querySelector(".sub-menu"), 300);
      }
    });
  });

  const newsletter = document.querySelector(".newsletter");
  const hamburger = document.querySelector(".hamburger");
  hamburger?.addEventListener("click", () => {
    if (hamburger.classList.contains("is-active")) {
      bodyScroll.unLock(300);
      hamburger.classList.remove("is-active");
      nav.classList.remove("active");
    } else {
      const offset = document.querySelector("header").getBoundingClientRect().top;
      let newsletterHeight = 0;

      if (document.querySelector(".newsletter") != null) {
        newsletterHeight = newsletter.getBoundingClientRect().height;
      } else {
        newsletterHeight = 0;
      }

      if (newsletter && offset > 0) {
        window.scroll({
          top: newsletterHeight,
          left: 0,
          behavior: "smooth",
        });

        const a = newsletterHeight - window.scrollY;
        const b = a < 0 ? a * -1 : a;

        setTimeout(() => {
          bodyScroll.lock(nav);
          hamburger.classList.add("is-active");
          nav.classList.add("active");
        }, Math.max(100, b * 1.5));
      } else {
        bodyScroll.lock(nav);
        hamburger.classList.add("is-active");
        nav.classList.add("active");
      }
    }
  });
}

/**
 * Portfolio Slider
 */
new Swiper(".portfolio-slider", {
  navigation: {
    nextEl: ".slider-arrow.-next",
    prevEl: ".slider-arrow.-prev",
  },
  simulateTouch: false,
  spaceBetween: 15,
  slidesPerView: 1,
  breakpoints: {
    576: {
      slidesPerView: 2,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    1170: {
      slidesPerView: 3,
      spaceBetween: 35,
    },
  },
});

/**
 * YouTube Embed
 */
const youtube = document.querySelectorAll(".youtube-embed");
youtube.forEach((block) => {
  const source = "https://img.youtube.com/vi/" + block.dataset.embed + "/sddefault.jpg";

  const image = new Image();
  image.src = source;
  image.addEventListener("load", () => {
    block.appendChild(image);
  });

  block.addEventListener("click", function () {
    const iframe = document.createElement("iframe");

    iframe.setAttribute("frameborder", "0");
    iframe.setAttribute("allowfullscreen", "");
    iframe.setAttribute(
      "src",
      "https://www.youtube.com/embed/" + this.dataset.embed + "?rel=0&showinfo=0&autoplay=1"
    );

    block.innerHTML = "";
    block.appendChild(iframe);
  });
});

/**
 * Partners Slider
 */
new Swiper(".partners-slider", {
  navigation: {
    nextEl: ".slider-arrow.-next",
    prevEl: ".slider-arrow.-prev",
  },
  simulateTouch: false,
  spaceBetween: 15,
  slidesPerView: 2,
  breakpoints: {
    576: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 4,
      spaceBetween: 20,
    },
    992: {
      slidesPerView: 5,
      spaceBetween: 20,
    },
    1170: {
      slidesPerView: 6,
      spaceBetween: 20,
    },
  },
});

/**
 * FAQ
 */
const faqItems = document.querySelectorAll(".faq-item");
faqItems.forEach((item) => {
  const trigger = item.querySelector(".faq-item-trigger"),
    content = item.querySelector(".faq-item-content");

  trigger.addEventListener("click", function () {
    trigger.classList.toggle("active");
    content.classList.toggle("active");
    // slideToggle(content, 300s);
  });
});